<template>
  <nav v-if="shouldPaginate" class="pagination">
    <span v-if="prevPage" class="prev">
      <a @click="goToPage(previousNumber())" class="btn-oval btn-oval--transparent">
        <span class="icon icon-arrow-left"></span>
      </a>
    </span>
    <span
      v-for="page in totalPages"
      :key="page"
      class="p-0"
    >
      <div v-if="shouldDisplayNumber(page)">
        <span
          v-if="isCurrentPage(page)"
          class="page current"
        >
          <a>{{page}}</a>
        </span>
        <span
          v-else
          class="page"
        >
          <a @click="goToPage(page)">
            {{page}}
          </a>
        </span>
      </div>
      <span
        v-else-if="shouldDisplayGap(page)"
        class="page gap"
      >
        <PageInput
          v-if="showInputGap"
          @inputValue="(value) => goToPage(value)"
        />
        <span v-else>...</span>
      </span>
    </span>
    <span v-if="nextPage" class="next">
      <a
        @click="goToPage(nextNumber())"
        class="btn-oval btn-oval--transparent"
      >
        <span class="icon icon-arrow-right"></span>
      </a>
    </span>
  </nav>
</template>

<script>
import { mapMutations } from 'vuex';
import {
  FIRST_PAGE,
  SECOND_PAGE,
  THIRD_PAGE,
  AUCTIONS_CATALOG_TYPE,
  EMPLOYEES_ORDERS_PANEL,
} from '@/shared/consts';
import PageInput from './input_page_number';

export default {
  name: 'Pagination',
  props: {
    meta: Object,
    showInputGap: Boolean,
    scrollPageToUp: Boolean,
  },
  data() {
    return {
      scrollPage: false,
    };
  },
  components: {
    PageInput,
  },
  computed: {
    prevPage() {
      return this.meta.prev_page;
    },
    nextPage() {
      return this.meta.next_page;
    },
    currentPage() {
      return this.meta.current_page;
    },
    totalPages() {
      return this.meta.total_pages;
    },
    shouldPaginate() {
      return this.meta && this.meta.total_pages !== 1;
    },
    isInternetAuctionCatalog() {
      return this.$route.name === AUCTIONS_CATALOG_TYPE.INTERNET;
    },
    isEmployeesOrdersPanel() {
      return this.$route.name === EMPLOYEES_ORDERS_PANEL;
    },
  },
  methods: {
    ...mapMutations(['SET_PAGE']),
    shouldDisplayNumber(pageNumber) {
      return Math.abs(pageNumber - this.currentPage) < THIRD_PAGE
        || pageNumber === FIRST_PAGE || pageNumber === this.totalPages;
    },
    shouldDisplayGap(pageNumber) {
      return pageNumber === SECOND_PAGE || pageNumber === (this.totalPages - FIRST_PAGE);
    },
    isCurrentPage(pageNumber) {
      return pageNumber === this.currentPage;
    },
    previousNumber() {
      return this.currentPage - 1;
    },
    nextNumber() {
      return this.currentPage + 1;
    },
    goToPage(pageNumber) {
      const historyState = Object.assign({},
        { name: this.$route.name }, this.newQueryParams(pageNumber));
      this.$router.push(historyState);
      if (this.isInternetAuctionCatalog || this.isEmployeesOrdersPanel) {
        this.updatePageParams(pageNumber);
      }
      if (this.scrollPageToUp) this.scrollPage = true;
    },
    newQueryParams(pageNumber) {
      const currentQueryParams = this.$route.query;
      return { query: Object.assign({}, currentQueryParams, { page: pageNumber }) };
    },
    updatePageParams(pageNumber) {
      this.SET_PAGE(Number(pageNumber));
    },
    scrollTop() {
      window.scrollTo(0, 0);
    },
  },
  updated() {
    if (this.scrollPage) {
      this.scrollTop();
      this.scrollPage = false;
    }
  },
};
</script>



// WEBPACK FOOTER //
// app/javascript/packs/shared/components/pagination/index.vue?50a69a22